import GetImvImages, { GetImagesWithNames } from "../../../../services/GetImages"
import { useState, useEffect } from "react"
import { supabase } from "../../../../services/storageClient"
import { PlusIcon } from "../../../assets/icons"
import { useMutation, useQuery } from "react-query"


export default function ImvEditImages(nreg) {
    // const images = GetImvImages(nreg)
    const markedForRemove = []
    const [newImages, setNewImages] = useState([])

    const { data, isLoading, error } = useQuery('images_edit', async () => {
        try {
            const listData = await supabase.storage.from('imv_images').list(`${nreg}`);
            //   console.log('data: ', listData);

            const _urlList = listData.data.map((image) => {
                // console.log("image: ", image.name)
                return supabase.storage.from('imv_images').getPublicUrl(`${nreg}/${image.name}`);
            });

            //   console.log('Images Url: ', _urlList)
            return _urlList; // Return the array of public URLs
        } catch (error) {
            console.error('Error fetching images:', error);
            throw error; // Re-throw the error for useQuery to handle
        }
    })

    useEffect(() => {
        console.log('images: ', data)
    }, [data])

    if (error) {
        throw error
    }

    const handleAddForRemove = (e) => {
        //* Verifica se a imagem selecionada ja esta na lista de remoção
        if (!markedForRemove.includes(e.target.name)) {
            markedForRemove.push(e.target.name)
        }

        console.log('A serem Removidas: ', markedForRemove)
    }

    const handleRemove = () => {
        markedForRemove.map((item) => {
            try {
                // supabase.storage.from('imv_images').remove(`${nreg}/${item}`)
                console.log(`Imagem ${item} removida`)
            } catch (error) {
                console.error('Erro ao Remover a (as) imagem', error)
            }
        })
    }


    const handleAddImages = (e) => {
        const fileList = e.target.files;

        // Convertendo a lista de arquivos para um array
        const imagesArray = Array.from(fileList);

        // Atualizando o estado com as imagens
        setNewImages(imagesArray);
    };

    const getImageDirectories = async () => {
        await supabase.storage.from('imv_images').list('').then((data) => {
            console.log('directories: ', data);
        })
    }

    //* Classes das Miniaturas das Imagens
    const miniImageClasses = "{`w-20 border aspect-square hover:brightness-50 rounded-lg cursor-pointer ${markedForRemove.includes(image.name) ? ' brightness-50' : ''}`}"
    return (<>
        <div className="grid gap-y-5 border p-5 rounded-lg">

            {/* Container grid de imagens atuais */}
            <Tip content={'Clique para remover uma imagem'}></Tip>

            <section className="flex ">
                <article className="grid w-1/2 grid-cols-4 py-5 gap-3 max-h-60 overflow-y-scroll border p-3 rounded-lg">
                    {data && data.length > 0 ? data.map((image) => (
                        <img onClick={(e) => handleAddForRemove(e)}
                            className={miniImageClasses}
                            alt={image.name} name={image.name}
                            src={image.data.publicUrl}
                        />
                    )) : <h2 className="text-center"> sem imagens </h2>}
                    {isLoading && <h2>Carregando... </h2> }
                </article>

                {/* Container que exibe as imagens marcadas para remoção -> removidas ao 'Aplicar' */}
                <article className="grid w-1/2 grid-cols-4 py-5 gap-3 max-h-60 overflow-y-scroll bg-[#fd171762] p-3 rounded-lg">
                    {markedForRemove.map((image_rm) => (
                        <img
                        // className={miniImageClasses}
                        // alt={images.name} name={image_rm.name}
                        // src={supabase.storage.from('imv_images').getPublicUrl(`${nreg}/${image_rm.name}`).data.publicUrl}
                        />
                    ))}
                </article>
            </section>

            {/* Figura Representativa para adicionar mais fotos */}
            <section className="flex gap-x-3">
                <figure className="w-20 aspect-square rounded-lg bg-[#0005]">
                    <label className="cursor-pointer w-20 " htmlFor="images_up">
                        <PlusIcon />
                    </label>

                    <input onChange={(e) => handleAddImages(e)} className="hidden" type="file" name="images_up" id="images_up" multiple={true} />

                </figure>
                {/* Container com as Imagens a serem adicionadas -> Adicionadas ao 'Aplicar' */}
                <article className="w-full flex gap-x-3 overflow-x-scroll">
                    {newImages.map((image, index) => (
                        <img
                            key={index}
                            src={URL.createObjectURL(image)}
                            alt={`Imagem ${index + 1}`}
                            className="w-20 border aspect-square hover:brightness-50 rounded-lg cursor-pointer"
                        />
                    ))}
                </article>
            </section>

            <section className="flex">
                <div className="w-full cursor-pointer p-3 rounded-lg text-center bg-[#e61e1e]"> Excluir Tudo </div>
                <div className="w-full"></div>
                <div onClick={() => handleRemove()} className="w-full cursor-pointer p-3 rounded-lg text-center bg-[#2e8140]"> Aplicar </div>
            </section>
        </div>

    </>)
}

const Tip = ({ content }) => {
    return (
        <p className="text-[#ceccdd] m-0 text-[8pt]"> {content} </p>
    )
}